
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { SpecialtyItemProps } from ".";
import { loading, find } from "store/specialty";

interface ApiSpecialtyFindByIdInputProps {
    id: number;
}

type ApiSpecialtyFindOutputProps = OutputBaseProps<{ item: SpecialtyItemProps; }, ApiSpecialtyFindByIdInputProps>;

export const apiSpecialtyFindById = async (data: ApiSpecialtyFindByIdInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiSpecialtyFindOutputProps>(`/api/specialty/${data.id}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};